<div class="yes-no-modal-content" (contextmenu)="$event.preventDefault()">
<div
  class="modal-header d-flex justify-content-between align-items-start border-bottom-0 pb-0"
  >
  <div class="modal-title">
    <h4>{{ question }}</h4>
  </div>
  <button
    type="button"
    class="close-btn yes-no-close-btn"
    (click)="closeModal()"
    title="Close"
    >
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<!--Body-->
<div class="modal-body pb-4">
  <!-- 'Is this the correct FFL?' -->
  @if (this.question === Questions.correct_ffl) {
    <div class="mb-4">
      <p>
        <span style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
          >FFL: </span
          >{{ this.optional_details["ffl"] }}
          <br />
          <span style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
            >Business Name: </span
            >{{ this.optional_details["business_name"] }}
            <br />
            <span style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
              >Legal Name: </span
              >{{ this.optional_details["legal_name"] }}
              <br />
              <span style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                >Address: </span
                >{{ this.optional_details["premise_street"]
                }}@if (this.optional_details['premise_street']) {
                <span>,</span>
              }
              {{ this.optional_details["premise_city"]
              }}@if (this.optional_details['premise_city']) {
              <span>,</span>
            }
            {{ this.optional_details["premise_state"]
            }}@if (this.optional_details['premise_state']) {
            <span>,</span>
          }
          {{ this.optional_details["premise_zip_code"] }}
          @if (!this.optional_details['premise_street']) {
            <span>N/A</span>
          }
          @if (this.optional_details['expiration_date']) {
            <br />
          }
          @if (this.optional_details['expiration_date']) {
            <span
              style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
              >Expires: </span
              >
              }{{ this.optional_details["expiration_date"] }}
            </p>
          </div>
        }

        <!-- 'Would you like to use this firearm data?' -->
        @if (
          this.question === Questions.use_this_firearm ||
          this.question === Questions.add_this_firearm
          ) {
          <div
            class="mb-4"
            >
            <p>
              <span style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                >Manufacture: </span
                >{{ this.optional_details["manufacture"] }} <br /><span
                style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                >Importer: </span
                >{{ this.optional_details["importer"] }} <br /><span
                style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                >Model: </span
                >{{ this.optional_details["model"] }} <br /><span
                style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                >Additional Markings: </span
                >{{ this.optional_details["additional_markings"] }} <br /><span
                style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                >Caliber / Gauge: </span
                >{{ this.optional_details["caliber_gauge"] }}
              </p>
            </div>
          }

          <!-- 'Would you like to use this product item data?' -->
          @if (this.question === Questions.add_product_item_data) {
            <div
              class="mb-4"
              >
              <p>
                <span style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                  >Name: </span
                  >{{ this.optional_details["upc"] }} <br /><span
                  style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                  >Description: </span
                  >{{ this.optional_details["description"] }} <br /><span
                  style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                  >Income Asset Account: </span
                  >{{ this.optional_details["income_asset_account"] }} <br /><span
                  style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                  >Income Account: </span
                  >{{ this.optional_details["income_account"] }} <br /><span
                  style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                  >Expense Account: </span
                  >{{ this.optional_details["expense_account"] }} <br /><span
                  style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                  >Inventory Asset Account: </span
                  >{{ this.optional_details["inventory_asset_account"] }}<br /><span
                  style="font-weight: bold; color: rgba(255, 255, 255, 0.7)"
                  >Reorder Point: </span
                  >{{ this.optional_details["reorder_point"] }}
                </p>
              </div>
            }

            <div class="d-flex justify-content-center gap-4 mt-2">
              <button
                class="btn modern-btn"
      [ngClass]="
        reverse_btn_color
          ? 'secondary-btn text-success'
          : 'secondary-btn text-danger'
      "
                style="min-width: 140px; flex: 1; font-size: 1.2rem"
                (click)="yesClick()"
                >
                <i class="fa-solid fa-check me-2"></i> Yes
              </button>

              <button
                class="btn modern-btn"
      [ngClass]="
        reverse_btn_color
          ? 'secondary-btn text-danger'
          : 'secondary-btn text-success'
      "
                style="min-width: 140px; flex: 1; font-size: 1.2rem"
                (click)="noClick()"
                >
                <i class="fa-solid fa-xmark me-2"></i> No
              </button>
            </div>
          </div>
        </div>
